import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  emailInput: {
    '& .MuiOutlinedInput-root': {
      '& input': {
        color: theme.palette.common.white,
        fontSize: 16,
      },
      '& fieldset': {
        borderColor: theme.palette.common.white,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.common.white,
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.common.white,
      },
    },
  },
  toggleButtonGroup: {
    display: 'flex',
    justifyContent: 'center',
    margin: 'auto',
    width: '100%',
    maxWidth: '60rem',
  },
  toggleButton: {
    border: `1px solid ${theme.palette.common.white}`,
    color: theme.palette.common.white,
    flex: '1 1 0',
    maxWidth: '30rem',
    minWidth: '150px',
    '&.Mui-selected:hover': {
      backgroundColor: theme.palette.primary.newAuth,
      color: theme.palette.common.white,
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.newAuth,
      color: theme.palette.common.white,
    },
  },
}))

export default styles
